import sources from 'helpers/sources';

import {
  SMS_OPT_OUT_INSTRUCTIONS_POLICY_OPTIONS
} from 'react/types/sms_settings';

import {
  SMS_OPT_OUT_POLICY_HINT_TEXT
} from 'react/types/constants';

angular.module('shared').controller('SendBulkMessageModalCtrl', ["$rootScope", "$scope", "$stateParams", "$modalInstance", "$http", "$filter", "$timeout", "flash", "ConfirmLeaveUnsavedChangesService", "DefaultReplyAddressService", "ContactCommunicationService", "TestEmailsService", "SmsValidationService", "TemplateValidationService", "AssetLibraryService", "PushNotificationOptionsService", "ConfirmBulkMessageService", "TemplateSanitizeService", "PushNotificationValidationService", "ReactModal", "contacts", "recipientIds", "defaultChannel", "bulkMessageParams", "existingTemplate", function($rootScope, $scope, $stateParams, $modalInstance, $http, $filter, $timeout, flash, ConfirmLeaveUnsavedChangesService, DefaultReplyAddressService, ContactCommunicationService, TestEmailsService, SmsValidationService, TemplateValidationService, AssetLibraryService, PushNotificationOptionsService, ConfirmBulkMessageService, TemplateSanitizeService, PushNotificationValidationService, ReactModal, contacts, recipientIds, defaultChannel, bulkMessageParams, existingTemplate) {
  var CHANNEL_MAP, contactsIds, getEmailSenderAddresses, getPlainContent, getPlainSubject, getRecipientsIds, gym, isContactUnsubscribed, isEmailSenderEligibleForWarning, loadPushNotificationRecipientInfo, loadSecondaryRecipients, loadTemplates, preselectRecipients, ref, ref1, ref2, ref3, ref4, ref5, ref6, sender, sortRecipients;
  $scope.gym = gym = $rootScope.gym;
  $scope.contactType = $stateParams.contactType;
  $scope.emailSenders = $scope.gym.reply_email_addresses;
  $scope.replyEmails = (function() {
    var i, len, ref, results;
    ref = $scope.emailSenders;
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      sender = ref[i];
      results.push(sender.email);
    }
    return results;
  })();
  $scope.pushNotificationRoutes = [
    {
      label: "No preference (open app to Notifications list)",
      value: ''
    }
  ];
  $scope.hasEvent = !!$stateParams.eventId;
  $scope.hasNonFreeEvent = bulkMessageParams.non_free_event;
  $scope.isRollCall = !!bulkMessageParams.roll_call_id;
  $scope.hideMergeTagsNote = $scope.isRollCall || bulkMessageParams.source === 'event_cancellation';
  $scope.pushNotificationRoutesContext = $scope.isRollCall ? 'roll_call' : null;
  $scope.drawerTitle = bulkMessageParams.source === 'event_cancellation' ? 'Send message' : 'Send message to selected contacts';
  CHANNEL_MAP = {
    'sms_message': 'sms',
    'email_message': 'email',
    'push_notification_message': 'push_notification'
  };
  if ((ref = $scope.template) != null) {
    ref.sms_opt_out_instructions_policy = ((ref1 = $scope.template) != null ? ref1.sms_opt_out_instructions_policy : void 0) || $scope.gym.sms_opt_out_instructions_policy;
  }
  if ((ref2 = $scope.template) != null) {
    ref2.push_notification_route_name = ((ref3 = $scope.template) != null ? ref3.push_notification_route_name : void 0) || ((ref4 = $scope.pushNotificationRoutes[0]) != null ? ref4.value : void 0) || '';
  }
  $scope.loadPushNotificationRoutes = function() {
    return PushNotificationOptionsService.getOptions($scope.gym.id, $scope.pushNotificationRoutesContext).then(function(data) {
      if (data.length) {
        return $scope.pushNotificationRoutes = $scope.pushNotificationRoutes.concat(data);
      } else {
        return $scope.pushNotificationRoutes = [];
      }
    }).catch(function(error) {
      return flash.error(error);
    });
  };
  $scope.loadPushNotificationRoutes();
  $scope.toggleAssetLibrary = function() {
    return AssetLibraryService.open({
      mode: 'select'
    }).then(function(asset) {
      $scope.template.push_notification_image_asset_id = asset.id;
      $scope.template.push_notification_image_url = asset.attached_url;
      return $scope.template.push_notification_image_thumb_url = asset.thumb_url;
    });
  };
  $scope.removeImage = function() {
    $scope.template.push_notification_image_asset_id = null;
    $scope.template.push_notification_image_url = null;
    return $scope.template.push_notification_image_thumb_url = null;
  };
  $scope.previewImage = function() {
    return ReactModal.open({
      component: 'PushNotificationImageModal',
      props: {
        imageUrl: $scope.template.push_notification_image_url,
        replaceImage: $scope.toggleAssetLibrary,
        removeImage: $scope.removeImage
      }
    });
  };
  $scope.smsHintText = SMS_OPT_OUT_POLICY_HINT_TEXT;
  $scope.smsOptOutInstructionsOptions = function() {
    if ($scope.contactType === 'prospects') {
      return $scope.prospectSmsOptions;
    } else if ($scope.contactType === 'non_attending_contacts') {
      return $scope.nacSmsOptions;
    } else if (bulkMessageParams.source === 'debtors_report' || $scope.contactType === 'members') {
      return $scope.membersSmsOptions;
    } else {
      return SMS_OPT_OUT_INSTRUCTIONS_POLICY_OPTIONS;
    }
  };
  $scope.resolveDefaultSmsOptionValue = function() {
    var defaultPolicy, ref5;
    defaultPolicy = ((ref5 = $scope.template) != null ? ref5.sms_opt_out_instructions_policy : void 0) != null ? $scope.template.sms_opt_out_instructions_policy : $scope.gym.sms_opt_out_instructions_policy;
    switch ($scope.contactType) {
      case 'prospects':
        return 'add_sms_opt_out_instructions_for_prospects_only';
      case 'non_attending_contacts':
        if (defaultPolicy !== 'add_sms_opt_out_instructions_for_all_contacts') {
          return 'add_sms_opt_out_instructions_for_prospects_and_cancelled_members_only';
        } else {
          return 'add_sms_opt_out_instructions_for_all_contacts';
        }
        break;
      default:
        return defaultPolicy;
    }
  };
  $scope.prospectSmsOptions = [
    {
      label: "Add opt-out instructions to all messages (required for Prospects)",
      value: "add_sms_opt_out_instructions_for_prospects_only"
    }
  ];
  $scope.membersSmsOptions = [
    {
      label: "Add opt-out instructions to all messages",
      value: "add_sms_opt_out_instructions_for_all_contacts"
    },
    {
      label: "Add opt-out instructions for messages sent to cancelled Members only",
      value: "add_sms_opt_out_instructions_for_prospects_and_cancelled_members_only"
    },
    {
      label: "Do not add opt-out instructions to messages",
      value: "add_sms_opt_out_instructions_for_prospects_only"
    }
  ];
  $scope.nacSmsOptions = [
    {
      label: "Add opt-out instructions to all messages",
      value: "add_sms_opt_out_instructions_for_all_contacts"
    },
    {
      label: "Do not add opt-out instructions to messages",
      value: "add_sms_opt_out_instructions_for_prospects_and_cancelled_members_only"
    }
  ];
  $scope.checkEmailAuthorization = function(email) {
    var isEmailAuthorized;
    isEmailAuthorized = $scope.emailSenders.find(function(item) {
      return item.email === email;
    });
    if (isEmailAuthorized) {
      return isEmailAuthorized.authorized;
    } else {
      return false;
    }
  };
  $scope.showEmailVerificationWarning = function(email) {
    var matchingSender;
    matchingSender = $scope.emailSenders.find(function(item) {
      return item.email === email;
    });
    if (matchingSender) {
      return !matchingSender.skip_warning;
    }
  };
  getEmailSenderAddresses = function() {
    var url;
    url = `/gyms/${$scope.gym.id}/reply_email_addresses`;
    return $http.get(url).then(function(response) {
      return $timeout(function() {
        return $scope.$apply(function() {
          return $scope.emailSenders = response.data;
        });
      }, 0);
    });
  };
  getEmailSenderAddresses();
  $scope.close = function(skipConfirmation) {
    if ($scope.close) {
      if ($scope.displayConfirmationOnClose && !skipConfirmation) {
        return $scope.openConfirmationModal().then(function() {
          return $timeout(function() {
            return $scope.$apply();
          });
        });
      } else {
        return $timeout(function() {
          return $scope.$apply(function() {
            if (bulkMessageParams.source === 'event_cancellation' && skipConfirmation !== true) {
              $rootScope.$broadcast('event-cancellation:drawer-dismissed');
            }
            return $modalInstance.dismiss('cancel');
          });
        });
      }
    }
  };
  $scope.openConfirmationModal = () => {
    return ReactModal.open({
      component: 'CloseUnsavedFormModal',
      props: {
        title: 'Close drawer',
        text: 'Are you sure? This will abandon any unsaved changes.',
        cancel: () => {
          $scope.displayConfirmationOnClose = false;
          if (bulkMessageParams.source === 'event_cancellation') {
            $rootScope.$broadcast('event-cancellation:drawer-dismissed');
          }
          return $modalInstance.dismiss('cancel');
        }
      }
    });
  };
  if (existingTemplate) {
    $scope.template = angular.extend({}, existingTemplate);
  } else {
    $scope.template = {
      channel: CHANNEL_MAP[defaultChannel] || 'email',
      reply_address: DefaultReplyAddressService.getDefaultEmail(),
      sms_opt_out_instructions_policy: $scope.resolveDefaultSmsOptionValue() || $scope.gym.sms_opt_out_instructions_policy,
      push_notification_route_name: ((ref5 = $scope.template) != null ? ref5.push_notification_route_name : void 0) || ((ref6 = $scope.pushNotificationRoutes[0]) != null ? ref6.value : void 0) || ''
    };
  }
  $timeout(function() {
    return $scope.displayConfirmationOnClose = false;
  });
  $scope.onTemplateEditorLoaded = function() {
    return $timeout(function() {
      return $scope.displayConfirmationOnClose = false;
    });
  };
  ConfirmLeaveUnsavedChangesService.watch($scope, 'template', {
    closeModal: function() {
      return $scope.close(true);
    }
  });
  contactsIds = contacts.map(function(item) {
    var contact, ref7;
    contact = item.contact ? item.contact : item;
    return contact.contact_id || contact.student_id || ((ref7 = contact.student) != null ? ref7.id : void 0) || contact.id;
  });
  $scope.templates = [];
  $scope.recipients = [];
  $scope.recipientsIds = recipientIds || [];
  $scope.isPushNotification = function() {
    return $scope.template.channel === 'push_notification';
  };
  loadPushNotificationRecipientInfo = function() {
    var filters, url;
    url = `/gyms/${$scope.gym.id}/mobile_app/push_notification_recipients/list`;
    filters = $scope.recipientsIds.length > 0 ? {
      contact_comms_recipient_ids: $scope.recipientsIds
    } : {
      contact_ids: contactsIds
    };
    return $http.post(url, {
      count: 1000,
      filters: filters
    }).then(function(response) {
      return $scope.pushNotificationRecipients = response.data.collection.map(function(item) {
        item.name = item.contact_name;
        return item;
      });
    });
  };
  if ($scope.gym.mobile_app_enabled && $scope.contactType !== 'prospects') {
    loadPushNotificationRecipientInfo();
  }
  $scope.pushNotificationsEnabled = function() {
    var ref7;
    if ($scope.contactType === 'prospects') {
      return false;
    }
    return $scope.gym.mobile_app_enabled && (((ref7 = $rootScope.mobileAppMeta) != null ? ref7.push_notifications_feature_enabled : void 0) || $scope.gym.push_notifications_feature_enabled);
  };
  $scope.pushNotificationAvailable = function(recipient) {
    var ref7;
    return (ref7 = recipient.push_notification_status) === 'notifiable' || ref7 === 'access_disabled';
  };
  $scope.isEventCancellation = function() {
    return bulkMessageParams.source === 'event_cancellation';
  };
  loadTemplates = function() {
    var params, url;
    params = {
      count: 1500,
      'filters[for_general_use]': true
    };
    $scope.isTemplatesLoading = true;
    url = sources.templates($scope.gym.id);
    return $http.get(url, {
      params: params
    }).then(function(response) {
      $scope.isTemplatesLoading = false;
      return $scope.templates = response.data.collection;
    });
  };
  preselectRecipients = function() {
    $scope.recipients = $scope.isPushNotification() ? $scope.pushNotificationRecipients : $scope.contactCommsRecipients;
    return $scope.recipients = $scope.recipients.map(function(item) {
      var baseSelection, ref7;
      baseSelection = (function() {
        switch ($scope.template.channel) {
          case 'sms':
            return item.sms_status === 'sms_accepted' && !item.unsubscribed_from_sms && !!item.recipient_phone_number;
          case 'email':
            return item.email_status === 'email_accepted' && !item.unsubscribed_from_email && !!item.recipient_email;
          case 'push_notification':
            return $scope.pushNotificationsEnabled() && $scope.pushNotificationAvailable(item) && item.contact_type.toLowerCase() !== 'prospect';
        }
      })();
      if (((ref7 = $scope.recipientsIds) != null ? ref7.length : void 0) && $scope.isEventCancellation()) {
        item.selected = $scope.recipientsIds.includes(item.id) && baseSelection;
      } else {
        item.selected = baseSelection;
      }
      return item;
    });
  };
  sortRecipients = function(recipients) {
    return _.sortBy(recipients, function(item) {
      var id, suffix;
      id = $filter('padStart')(item.contact_id, 10);
      suffix = item.for_primary_contact ? '1' : '2';
      return `${id}_${suffix}`;
    });
  };
  loadSecondaryRecipients = function() {
    var params, recipientLimit, ref7, url;
    url = `/gyms/${$stateParams.gymId}/contact_comms_recipients/list`;
    recipientLimit = $scope.gym.gym_config.bulk_comms_recipient_limit;
    params = {
      count: recipientLimit,
      filters: ((ref7 = $scope.recipientsIds) != null ? ref7.length : void 0) && !$scope.isEventCancellation() ? {
        contact_comms_recipient_ids: $scope.recipientsIds
      } : {
        contact_ids: contactsIds
      }
    };
    return $http.post(url, params).then(function(response) {
      if (response.data.collection) {
        $scope.contactCommsRecipients = sortRecipients(response.data.collection).map(function(item) {
          item.name = item.name || item.family_member_name || item.contact_name;
          item.unsubscribed_from_email = item.email_status === 'email_unsubscribed';
          item.unsubscribed_from_sms = item.sms_status === 'sms_unsubscribed';
          item.contact_id = item.for_primary_contact ? item.contact_id : item.family_member_id;
          item.contact_type = item.for_primary_contact ? item.contact_type : item.family_member_type;
          return item;
        });
        $scope.recipients = $scope.contactCommsRecipients;
        return preselectRecipients();
      }
    });
  };
  loadTemplates();
  loadSecondaryRecipients();
  $scope.isContactUnsubscribed = isContactUnsubscribed = function(recipient) {
    switch ($scope.template.channel) {
      case 'sms':
        return recipient.unsubscribed_from_sms || !recipient.recipient_phone_number;
      case 'email':
        return recipient.unsubscribed_from_email || !recipient.recipient_email;
      case 'push_notification':
        return !$scope.pushNotificationAvailable(recipient);
    }
  };
  $scope.onTemplateChanged = function(templateId) {
    var base, ref10, ref7, ref8, ref9;
    $scope.template = angular.extend({}, $scope.templates.find(function(item) {
      return item.id === templateId;
    }));
    $scope.template.key = Math.floor(Math.random() * 1000000);
    (base = $scope.template).channel || (base.channel = 'email');
    $scope.template.reply_address = DefaultReplyAddressService.getDefaultEmail();
    $scope.template.sms_opt_out_instructions_policy = $scope.resolveDefaultSmsOptionValue();
    $scope.template.push_notification_route_name = ((ref7 = $scope.template) != null ? ref7.push_notification_route_name : void 0) || ((ref8 = $scope.pushNotificationRoutes[0]) != null ? ref8.value : void 0) || '';
    $scope.template_push_notification_image_url = (ref9 = $scope.template) != null ? ref9.push_notification_image_url : void 0;
    $scope.template.push_notification_image_thumb_url = (ref10 = $scope.template) != null ? ref10.push_notification_image_thumb_url : void 0;
    preselectRecipients();
    return $timeout(function() {
      return $scope.displayConfirmationOnClose = false;
    });
  };
  $scope.onChannelChange = function() {
    return preselectRecipients();
  };
  $scope.submitTemplate = function(template) {
    var confirmParams;
    if (template.push_notification_route_name === '') {
      template.push_notification_route_name = null;
    }
    if ('push_notification_image_url' in template) {
      delete template.push_notification_image_url;
    }
    if ('push_notification_image_thumb_url' in template) {
      delete template.push_notification_image_thumb_url;
    }
    confirmParams = {
      template: $scope.template,
      recipientList: $scope.recipients
    };
    if (bulkMessageParams.source === 'event_cancellation') {
      ConfirmBulkMessageService.confirm(confirmParams, $rootScope.gym).then(function() {
        var broadcastData, sanitizedTemplate;
        sanitizedTemplate = TemplateSanitizeService.sanitize($scope.template);
        broadcastData = {
          subject: sanitizedTemplate.subject,
          content: sanitizedTemplate.content,
          body: sanitizedTemplate.content,
          recipientsCount: getRecipientsIds().length,
          recipientIds: getRecipientsIds(),
          replyEmail: sanitizedTemplate.reply_address,
          reply_email: sanitizedTemplate.reply_address,
          channel: sanitizedTemplate.channel,
          sms_opt_out_instructions_policy: sanitizedTemplate.sms_opt_out_instructions_policy,
          push_notification_route_name: sanitizedTemplate.push_notification_route_name,
          push_notification_image_asset_id: sanitizedTemplate.push_notification_image_asset_id
        };
        $rootScope.$broadcast('event-cancellation:bulk-message-sent', broadcastData);
        return $scope.close(true);
      });
      return;
    }
    return ConfirmBulkMessageService.confirm(confirmParams, $rootScope.gym).then(function() {
      var data, url;
      $scope.isLoading = true;
      template = TemplateSanitizeService.sanitize($scope.template);
      template.roll_call_id = bulkMessageParams.roll_call_id;
      template.membership_interruption_request_id = bulkMessageParams.membership_interruption_request_id;
      data = {
        bulk_message: {
          contact_comms_recipient_ids: getRecipientsIds(),
          template_options: template,
          source: bulkMessageParams.source
        }
      };
      url = `/gyms/${gym.id}/bulk_messages`;
      $http.post(url, data).then(function() {
        flash.success = 'Messages were sent successfully';
        getEmailSenderAddresses();
        return $scope.close(true);
      });
      return function() {
        flash.error = 'There was an error sending the messages';
        return $scope.isLoading = false;
      };
    });
  };
  $scope.sendTemplate = function(template) {
    if (isEmailSenderEligibleForWarning(template)) {
      $scope.openUnverifiedEmailSenderWarningModal(template.reply_address, function() {
        return $scope.submitTemplate(template);
      });
    } else {
      return $scope.submitTemplate(template);
    }
  };
  isEmailSenderEligibleForWarning = function(template) {
    return template.channel === 'email' && !$scope.checkEmailAuthorization(template.reply_address) && $scope.showEmailVerificationWarning(template.reply_address);
  };
  getRecipientsIds = function() {
    var selectedRecipients;
    selectedRecipients = $scope.recipients.filter(function(item) {
      return item.selected;
    });
    return selectedRecipients.map(function(item) {
      return item.id;
    });
  };
  $scope.isFreemiumWithoutPaymentMethod = function() {
    return $scope.template.channel === 'sms' && $scope.gym.on_freemium && !$scope.gym.subscription_payment_method_present && $scope.gym.sms_enabled;
  };
  $scope.requiresObject = function() {
    return $scope.template.requires_object && (($scope.template.requires_booking_object && !$scope.hasEvent) || ($scope.template.requires_membership_object && !$scope.hasEvent) || $scope.template.requires_invoice_object || $scope.template.requires_member_style_object || $scope.template.requires_member_grading_object || $scope.template.requires_contact_suspension_object || $scope.template.requires_recurring_booking_detail_object || $scope.template.requires_late_booking_cancellation_object || $scope.template.requires_waitlist_attendee_object || $scope.template.requires_performed_workout_object);
  };
  $scope.phoneNumberInvalid = function() {
    var template;
    template = $scope.template;
    return template.channel === 'sms' && !getRecipientsIds().length;
  };
  getPlainSubject = function(subject) {
    return $filter('sanitizeEditorField')(subject || '', true, {
      target: 'subject'
    });
  };
  getPlainContent = function(content) {
    return $filter('sanitizeEditorField')(content || '', true);
  };
  $scope.isMessageReady = function(template) {
    var contentValid, recipientsCount, subjectValid;
    recipientsCount = getRecipientsIds().length;
    if (!recipientsCount) {
      return false;
    }
    if ($scope.requiresObject() || $scope.isLoading) {
      return false;
    }
    $scope.error = SmsValidationService.getErrors(template);
    if ($scope.error) {
      return false;
    }
    if (template && template.channel) {
      subjectValid = TemplateValidationService.subjectIsNotEmpty(template.subject);
      contentValid = TemplateValidationService.contentIsNotEmpty(template.content);
      switch (template.channel) {
        case 'email':
          return contentValid && subjectValid && $scope.gym.custom_emails_enabled;
        case 'push_notification':
          return contentValid && subjectValid && $scope.pushNotificationsEnabled() && PushNotificationValidationService.isLengthValid(template.content);
        default:
          return $scope.gym.sms_enabled && contentValid && SmsValidationService.isLengthValid(template.content) && !$scope.isFreemiumWithoutPaymentMethod();
      }
    }
  };
  $scope.sendLabel = function() {
    var channel, count, counter, type;
    if ($scope.isEventCancellation()) {
      return 'Save';
    }
    channel = $scope.template.channel;
    count = getRecipientsIds().length;
    counter = count > 1 ? `(${count})` : '';
    type = (function() {
      switch (false) {
        case !(channel === 'sms' && count !== 1):
          return 'SMSes';
        case !(channel === 'sms' && count === 1):
          return 'SMS';
        case !(channel === 'email' && count !== 1):
          return 'Emails';
        case !(channel === 'email' && count === 1):
          return 'Email';
        case !(channel === 'push_notification' && count !== 1):
          return 'Push Notifications';
        case !(channel === 'push_notification' && count === 1):
          return 'Push Notification';
        default:
          return '';
      }
    })();
    return `Send ${counter} ${type}`;
  };
  $scope.cancelLabel = function() {
    if ($scope.isEventCancellation()) {
      return 'Discard';
    } else {
      return 'Cancel';
    }
  };
  $scope.testEmailReady = function() {
    return $scope.template.channel === 'email' && $scope.gym.custom_emails_enabled && $scope.isMessageReady($scope.template);
  };
  $scope.openUnverifiedEmailSenderWarningModal = function(email, submitFunction) {
    return ReactModal.open({
      component: 'UnverifiedEmailSenderWarningModal',
      props: {
        unverifiedEmailAddress: email,
        onSubmit: submitFunction
      }
    });
  };
  return $scope.sendTestEmail = function() {
    var params;
    params = {
      subject: $scope.template.subject,
      content: $scope.template.content,
      head_tag_content: $scope.template.head_tag_content,
      reply_address: window.currentUser.email,
      contact: contacts.length === 1 ? contacts[0] : void 0
    };
    return TestEmailsService.sendTestEmail(params);
  };
}]);
